/* unplugin-vue-components disabled */import script from "./ProjectView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectView.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectView.vue?vue&type=style&index=0&id=8d77b7d6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8d77b7d6"]])

export default __exports__